import { render, staticRenderFns } from "./RecommendItem.vue?vue&type=template&id=b49c17c8&scoped=true&"
import script from "./RecommendItem.vue?vue&type=script&lang=js&"
export * from "./RecommendItem.vue?vue&type=script&lang=js&"
import style0 from "./RecommendItem.vue?vue&type=style&index=0&id=b49c17c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49c17c8",
  null
  
)

export default component.exports